module.exports = __webpack_public_path__ + "static/media/sweden.00c92941.svg";